import React from 'react';
import {
  Edit,
  SelectInput,
  TextInput,
  BooleanInput,
  NumberInput,
  DateInput,
  FormDataConsumer,
  SimpleForm,
  required,
  SaveButton,
  Toolbar,
  TopToolbar,
  translate,
} from 'react-admin';
import Button from '@material-ui/core/Button';
import { useLocale } from 'react-admin';
import DeeplinkIcon from '@material-ui/icons/OpenInNew';

const NotificationEditActions = ({ basePath }) => (
  <TopToolbar>
    <Button
      variant="outlined"
      startIcon={<DeeplinkIcon />}
      size="small"
      style={{ marginRight: 50 }}
      onClick={() => { window.open(`https://github.com/kodira/bloomup/wiki/BloomUp-Spec-(WIP)#deep-links`, '_blank') }}
    >
      Deep-Links
    </Button>
  </TopToolbar>
);

const NotificationEditToolbar = translate(({ onCancel, translate, ...props }) => (
  <Toolbar {...props}>
    <SaveButton />
    <Button m={5} onClick={onCancel}>{translate('ra.action.cancel')}</Button>
  </Toolbar>
));

const notificationCategories = [
  { item: 'PROMOTION', label: 'Promotions' },
  { item: 'NOTIFICATION', label: 'Benachrichtigungen' },
  { item: 'EVALUATION', label: 'Testzeitraum' },
  { item: 'GAMIFICATION', label: 'Gamification' },
];

const NotificationEdit = ({ onCancel, ...props }) => {
  const locale = useLocale();

  const redirect = (basePath, id, data) => {
    const categoryFilterString = JSON.stringify({ category: data.category });
    return (`${basePath}?filter=${encodeURIComponent(categoryFilterString)}`);
  };

  return (
  <Edit title=" " {...props} actions={<NotificationEditActions />}>
    <SimpleForm redirect={redirect} toolbar={<NotificationEditToolbar onCancel={onCancel} />}>
      <TextInput source="id" disabled />
      <TextInput source="uuid" />
      <SelectInput source="category" choices={notificationCategories} defaultValue={'quote'} optionValue="item" optionText="label" />
      <TextInput source="title" validate={required()} />
      <TextInput source="subTitle" />
      <TextInput source="body" />
      <TextInput source="url" />
      <BooleanInput source="notify" label="Smartphone-Notification (wird auch außerhalb der App angezeigt)" />
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          let inputs;

          switch(formData.category) {
            case 'EVALUATION':
              inputs = <>
                <NumberInput
                  label="Tageszahl"
                  source="validFrom"
                  parse={val => {
                    const parsed = (new Date(`2000-01-${Math.max(Math.min(val, 30), 1)}`)).toDateString();
                    return parsed;
                  }}
                  format={val => (new Date(val)).getDate() }
                />
                <BooleanInput source="showAfterEvaluationPeriod" />
              </>;
              break;
              case 'GAMIFICATION':
                inputs = <>
                  <NumberInput label="Punkteschwelle" source="pointThreshold" />
                  <TextInput fullWidth multiline rows={20} label="Mail-Inhalt" source="mailContent" />
                </>;
                break;
              default:
                inputs = <>
                  <DateInput source="validFrom" />
                  <DateInput source="validUntil" />
                </>
                break;
          }

          return inputs;
        }}
      </FormDataConsumer>
    </SimpleForm>
  </Edit>
)};

export default NotificationEdit;
